import { useState, useCallback } from "react";
import IUserUI from "@models/IUserUI";
import ISupplierModel from "@models/ISupplierModel";
import IVendor_Source from "@models/IVendor_Source";
import VendorSourceService from "@services/VendorSourceService";

export const useVendorSourceTypeahead = (userModel: IUserUI, supplierModel: ISupplierModel) => {
    const [vendorSourceOptions, setVendorSourceOptions] = useState<IVendor_Source[]>([]);
    const [selectedVendorSource, setSelectedVendorSource] = useState<IVendor_Source | null>(null);
    const [resetVendorSource, setResetVendorSource] = useState<boolean>(false);

    const lookupVendorSource = useCallback(
        async (name: string) => {
            if (!name) return;
            try {
                const vendorSources = await VendorSourceService.getVendorSources(name, userModel, supplierModel);
                setVendorSourceOptions(vendorSources);
            } catch (error) {
                console.error("Error searching vendor sources:", error);
            }
        },
        [userModel, supplierModel]
    );

    const selectVendorSource = useCallback((option: IVendor_Source) => {
        setSelectedVendorSource(option);
    }, []);

    const clearVendorSource = useCallback(() => {
        setSelectedVendorSource(null);
    }, []);

    const resetVendorSourceFn = useCallback(() => {
        setSelectedVendorSource(null);
        setResetVendorSource(false);
    }, []);

    return {
        vendorSourceOptions,
        selectedVendorSource,
        resetVendorSource,
        lookupVendorSource,
        selectVendorSource,
        clearVendorSource,
        resetVendorSourceFn,
    };
};
